import { MODAL_OTP_SETUP_STATUS, useOtpPhoneConfirmationSetup } from 'Utilities/hooks/useOtpPhoneConfirmationSetup';

import { OtpSetupModal } from './OtpSetupModal';
import { type OtpSetupModalProps, OtpSetupModalVariant } from './OtpSetupModal.types';

type OtpSetupModalContainerProps = Required<Pick<OtpSetupModalProps, 'origin'>>;

export const OtpSetupModalContainer: React.FC<OtpSetupModalContainerProps> = ({ origin }) => {
	const { setModalState, shouldShowOtpPhoneConfirmationModal, shouldShowOtpPhoneConfirmationSuccessModal } =
		useOtpPhoneConfirmationSetup();

	return (
		<OtpSetupModal
			onDismiss={() => {
				setModalState(MODAL_OTP_SETUP_STATUS.SHOWN);
			}}
			onSuccess={() => setModalState(MODAL_OTP_SETUP_STATUS.SUCCESS)}
			origin={origin}
			show={shouldShowOtpPhoneConfirmationModal}
			variant={shouldShowOtpPhoneConfirmationSuccessModal ? OtpSetupModalVariant.SUCCESS : OtpSetupModalVariant.FORM}
		/>
	);
};
